<template>
  <div class="opc-cart__empty" v-if="is">
    <div class="opc-cart__empty__info">{{ $t('billing.cart_empty_info') }}</div>
    <div class="opc-cart__empty__action">
      <zm-button type="primary" round size="large" @click="browse">
        {{ $t('billing.cart_empty_browse') }}
      </zm-button>
    </div>
  </div>
</template>

<script>
import { modalHybrid, navigateParentWindowTo } from '@/utils/modal-utils';
import persistShoppingBag from '@/views/config/shopping-cart/persist/persist-cart';
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getSelectedPlans']),
    is() {
      if (modalHybrid.isInWebview) return false;
      if (this.getSelectedPlans.length == 0) return true;
      return false;
    },
  },
  methods: {
    browse(){
      this.$tracking.persistentCart('cart empty state - browse products');
      const url = "/pricing";
      if(this.$context.is.modal){
        navigateParentWindowTo(url);
      }else{
        persistShoppingBag.continueShopping();
        // window.location.href = url;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.opc-cart__empty {
  &__info {
    font-family: Almaden Sans;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0%;
    color: #666487;
  }
  &__action {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}
</style>
